import * as React from "react";
import { connect } from "react-redux";
import Header from "./Header";
import { MultipleChoiceForm } from "./MultipleChoiceForm";
import { Choice } from "../../models/choice";
import { FormStep, Step } from "../../store/application/applicationState";
import { ApplicationAction, setCarCount, gotoStep } from "../../store/application/applicationActions";
import ApplicationContent from "../applicationContent";
import ApplicationFooter from "../applicationFooter";
import { Row, Col, Button, FormGroup, Input } from "reactstrap";
import { trackEvent } from "../../util/gtm";
import { SelectOne, Option } from "./SelectOneForm";
import { Car } from "../../lib-api/models/Car";
import { RootState } from "../../store";
import { CarType } from "../../lib-api/models/CarType";
import CurrencyInput from "./CurrencyInput";

import { CarLeaseAttribute } from "../../models/carleaseattribute";

interface State {
    cars: Array<Car>
    tempCars: Array<Car>
    dirty: boolean

}

type Props = ReturnType<typeof mapDispatchToProps & ReturnType<typeof mapStateToProps>>;

class Cars extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            cars: [],
            tempCars: [],
            dirty: false
        }
    }
    clickedCarAmount(val): void {
        const cars: Car[] = [];
        for (var i = 0; i < val; i++) {
            cars.push({});
        }
        if (cars.length == 0) {
            this.props.setCarCount(this.state.cars)
        }
        else {
            this.setState({
                cars: cars
            });
        }

    }


    next(): void {
        this.setState({ dirty: true });

        let leaseAmountValid = true;

        for (var i = 0; i < this.state.cars.length; i++) {
            if (this.state.cars[i].carType == CarType.Leaset) {
                const test = !CarLeaseAttribute.hasError(this.state.cars[i].leaseAmount);
                if (test != true) {
                    leaseAmountValid = false
                }


            }

        }
        let cartypes = false;

        for (var i = 0; i < this.state.cars.length; i++) {
            if (this.state.cars[i].carType == CarType.Egen || this.state.cars[i].carType == CarType.Leaset || this.state.cars[i].carType == CarType.Firma) {
                cartypes = true;

            }
            else {
                cartypes = false;
            }

   
        }

        if (leaseAmountValid === true && cartypes) {
            //all good.


            this.props.setCarCount(this.state.cars)
            trackEvent(
                "Biler i husstanden",
                this.state.cars.length + "biler",
                "Biler",
                this.state.cars.length + "biler"
            )
        }

    }

    resetCars(): void {
        this.setState({
            cars: [],
            tempCars: []
        });
    }

    private choices: Array<Choice<number>> = [
        new Choice<number>("0", 0, () => this.clickedCarAmount(0)),
        new Choice<number>("1", 1, () => this.clickedCarAmount(1)),
        new Choice<number>("2", 2, () => this.clickedCarAmount(2)),
        new Choice<number>("3+", 3, () => this.clickedCarAmount(3))
    ]
    private carTypeOptions: Array<Option<CarType>> = [
        new Option<CarType>("Egen bil", CarType.Egen),
        new Option<CarType>("Leaset bil", CarType.Leaset),
        new Option<CarType>("Firmabil", CarType.Firma)
    ]
    render() {
        var params = window.location.search.toString();
        var regex = /((&|\?)step=)[0-9]{1,2}/gi;
        if (params != "") {
            params = params.replace(regex, "$1" + "10");
        }
        var stepQuery = window.location.protocol + "//" + window.location.host + window.location.pathname + params;
        window.history.pushState({ path: stepQuery }, '', stepQuery)
        return (
            <div>
                <Header formStep={FormStep.Other} step={Step.Cars} />
                <ApplicationContent>
                    {this.state.cars.length == 0 &&
                        <MultipleChoiceForm
                            title="Biler i husstanden"
                            paragraph="Hvor mange biler er der i husstanden?"
                            choices={this.choices}
                        />}
                    {this.state.cars.length > 0 &&
                        <div>
                            <div className="row"><div className="text-center col"><h3 className="text-uppercase">biler i husstanden</h3></div></div>
                            <div className="row"><div className="text-center col"><p>Vælg type bil</p></div></div>
                        </div>
                    }
                    {this.state.cars.length > 0 &&

                        this.state.cars.map((car, index) => (<div className="carsButtons" key={index}>

                            <div className="row"><div className="text-center col"><h4 className="text-uppercase">Bil {index + 1}</h4></div></div>

                            <SelectOne
                                title=""
                                id={index + ""}
                                paragraph=""
                                options={this.carTypeOptions}
                                currentOption={this.carTypeOptions.find(x => x.getValue() == car.carType)}
                                optionChosen={(option) => {

                                    const newcars = this.state.cars;
                                    newcars[index].carType = option.getValue()
                                    this.setState({
                                        cars: newcars
                                    });

                                }}
                            />

                            <Row className="justify-content-center">
                                <div className="col-6 col-sm-4 col-md-3 py-2 px-2">
                                    {car.carType == CarType.Leaset && <FormGroup id="leaseAmountInput">

                                        <div className="text-center col"><p>Skriv beløb</p></div>

                                        <CurrencyInput
                                            maskOptions
                                            className={
                                                this.state.dirty && CarLeaseAttribute.hasError(car.leaseAmount)
                                                    ? "is-invalid form-control"
                                                    : "form-control"

                                            }
                                            type="text"
                                            id="leaseAmount"
                                            name="leaseAmount"
                                            placeholder="kr."
                                            value={car.leaseAmount}



                                            onChange={event => {
                                                const newcars = this.state.cars;
                                                newcars[index].leaseAmount = event.target.value;
                                                this.setState({
                                                    cars: newcars
                                                });
                                            }
                                            }
                                        />
                                        {this.state.dirty &&

                                            CarLeaseAttribute.hasError(car.leaseAmount) && (
                                                <div className="invalid-feedback">
                                                    {CarLeaseAttribute.getErrorMessage()}
                                                </div>
                                            )}
                                    </FormGroup>}
                                </div>
                            </Row>
                            <br />

                        </div>))
                    }




                </ApplicationContent>
                <ApplicationFooter>
                    <Row className="mt-2">
                        <Col className="col-12 text-right">
                            {this.state.cars.length > 0 &&
                                <Button className="back" onClick={() => this.resetCars()}>
                                    Tilbage
                            </Button>
                            }

                            {this.state.cars.length == 0 &&
                                <Button className="back" onClick={() => this.props.previous()}>
                                    Tilbage
                            </Button>
                            }

                            {this.state.cars.length > 0 &&
                                <Button className="next" onClick={() => {
                                    this.next();

                                }}>
                                    Næste
                        </Button>}
                        </Col>
                    </Row>
                </ApplicationFooter>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch: (action: ApplicationAction) => void) => ({
    setCarCount: (cars: Array<Car>) => {
        dispatch(setCarCount(cars));

    },
    previous: () => dispatch(gotoStep(Step.Dwelling))
});
const mapStateToProps = (state: RootState) => ({
    cars: state.applicationState.data.cars
});
export default connect(mapStateToProps, mapDispatchToProps)(Cars);